import React from 'react';
import { motion } from 'framer-motion';

const Header = ({ onTitleClick }) => {
  return (
    <motion.header
      className="bg-gradient-to-r from-blue-600 to-purple-700 text-white p-6 rounded-t-3xl shadow-lg"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, damping: 10, delay: 0.2 }}
    >
      <h1
        className="text-4xl font-extrabold text-center cursor-pointer hover:scale-105 transition-transform duration-300"
        onClick={onTitleClick}
      >
        WHERE?
      </h1>
    </motion.header>
  );
};

export default Header;